import {
  ActionIcon,
  Box,
  Button,
  Checkbox,
  ComboboxItem,
  Divider,
  Fieldset,
  Flex,
  Grid,
  Group,
  LoadingOverlay,
  NumberInput,
  Select,
  Stack,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconCaretLeft,
  IconCaretRight,
  IconCirclePlus,
  IconWindow,
} from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { repositoryMdm, repositoryPos } from "../../../_base/_const/_constVar";
import {
  getItemFromData,
  getValueById,
} from "../../../_base/helper/FunctionHelper";
import { MessageResponse } from "../../../model/MessageResponse";
import { getTblDmCustomerGroupSelect } from "../../../service/getSelectApi";

interface nameAddress {
  provinceName: string;
  communeName: string;
}

const DetailDataView = ({ id }: DetailDataViewProps) => {
  const entity = {
    id: 0,
    code: null,
    name: null,
    email: null,
    active: false,
    address: null,
    birthOfDate: null,
    contact: null,
    description: null,
    fax: null,
    parentId: null,
    sex: null,
    taxCode: null,
    telephoneNumber: null,
    type: null,
    groupId: null,
    groupName: null,
    attribute1: null,
    attribute2: null,
    attribute3: null,
    attribute4: null,
    attribute5: null,
    listInfoCustomers: [
      {
        stt: 1,
        name: null,
        sex: null,
        birthOfDate: null,
        telephoneNumber: null,
        attribute1: null, //dùng để lưu email cho khách hàng là doanh nghiệp
        attribute2: null,
        attribute3: null,
      },
    ],
    listInfoAddress: [
      {
        stt: 1,
        province: null,
        district: null,
        commune: null,
        address: null,
        attribute1: null,
        attribute2: null,
        attribute3: null,
      },
    ],
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [dataTblCustomerGroup, setDataTblCustomerGroup] = useState<
    { value: string; label: string; att1: string }[]
  >([]);
  const [dataTblProvince, setDataTblProvince] = useState<ComboboxItem[]>([]);
  const [dataTblDistrict, setDataTblDistrict] = useState<ComboboxItem[]>([]);
  const [dataTblCommune, setDataTblCommune] = useState<ComboboxItem[]>([]);
  const [listInfoAddressText, setListInfoAddressText] = useState<nameAddress>({
    provinceName: "",
    communeName: "",
  });
  const [addressCurrentVAT, setAddressCurrentVAT] = useState<string>("");
  const [dataTblDebtGroup, setDataTblDebtGroup] = useState<ComboboxItem[]>([]);

  const form = useForm<any>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
  });

  //thực hiện cho màn edit với doanh nghiệp
  const [currentIndexKH, setcurrentIndexKH] = useState(0);
  const [currentIndexKHDC, setcurrentIndexKHDC] = useState(0); //cho màn KH
  const nextCustomer = (type: number) => {
    if (type === 1) {
      if (currentIndexKH < form.getValues().listInfoCustomers.length - 1) {
        setcurrentIndexKH(currentIndexKH + 1);
      }
    } else {
      if (currentIndexKHDC < form.getValues().listInfoAddress.length - 1) {
        setcurrentIndexKHDC(currentIndexKHDC + 1);
      }
    }
  };

  const prevCustomer = (type: number) => {
    if (type === 1) {
      if (currentIndexKH > 0) {
        setcurrentIndexKH(currentIndexKH - 1);
      }
    } else {
      if (currentIndexKHDC > 0) {
        setcurrentIndexKHDC(currentIndexKHDC - 1);
      }
    }
  };
  const callApiGetData = async () => {
    open();
    await Promise.all([
      fetchDataDebt(),
      dataCustomerGroupSelect(),
      dataProvinceSelect(),
    ]);
    // const callApi = await repositoryPos.get<MessageResponse<any>>(
    //   `/api/v1/TblDmCustomer/get-detail?Id=${id}`
    // );
    const callApi = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmCustomer/get-detail?Id=${id}`,
    );
    if (callApi?.success) {
      const dataApi = callApi?.data;
      if (dataApi !== null) {
        setAddressCurrentVAT(dataApi?.attribute16 || "");
        form.setValues({
          ...dataApi,
          attribute12: dataApi?.attribute12 === "true" ? true : false,
          listInfoAddress:
            dataApi?.listInfoAddress &&
            String(dataApi?.listInfoAddress).length > 0 &&
            dataApi?.listInfoAddress !== "[]"
              ? Array.isArray(JSON.parse(dataApi?.listInfoAddress || "[]"))
                ? JSON.parse(dataApi?.listInfoAddress || "[]")
                : [JSON.parse(dataApi?.listInfoAddress || "{}")]
              : Array.isArray(JSON.parse(dataApi?.attribute11 || "[]"))
                ? JSON.parse(dataApi?.attribute11 || "[]")
                : [JSON.parse(dataApi?.attribute11 || "{}")],

          listInfoCustomers: Array.isArray(
            JSON.parse(dataApi?.listInfoCustomers || "[]"),
          )
            ? JSON.parse(dataApi?.listInfoCustomers || "[]")
            : [JSON.parse(dataApi?.listInfoCustomers || "{}")],
        });
        form.resetDirty(dataApi);
      }
      close();
    }
  };

  const dataCustomerGroupSelect = async () => {
    try {
      const getData = await getTblDmCustomerGroupSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
        att1: item.att1,
      }));
      setDataTblCustomerGroup(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const dataProvinceSelect = async () => {
    try {
      const getData = await repositoryMdm.get(
        "/api/v1/TblDmProvinceMoi/get-list?Active=true&Skip=0&Take=500",
      );
      const filteredData = getData?.data?.filter(
        (item: any) => item.id != null && item.name != null,
      );
      const mappedData = filteredData?.map((item: any) => ({
        value: String(item.id),
        label: item.name,
      }));
      setDataTblProvince(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  // const dataDistrictlSelect = async (idProvince: string) => {
  //   try {
  //     const getData = await getDistrictSelect(idProvince);
  //     const filteredData = getData?.filter(
  //       (item) => item.value != null && item.text != null
  //     );
  //     const mappedData = filteredData?.map((item) => ({
  //       value: item.value,
  //       label: item.text,
  //     }));
  //     setDataTblDistrict(mappedData);
  //   } catch (error) {
  //     console.error("Error in dataTblLocation: ", error);
  //   }
  // };

  const dataCommuneSelect = async (idProvince: string) => {
    try {
      const getData = await repositoryMdm.get(
        `/api/v1/TblDmCommuneMoi/get-select?ProvinceIds=${idProvince}`,
      );
      const filteredData = getData?.data?.filter(
        (item: any) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item: any) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblCommune(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const fetchDataDebt = async () => {
    const search = form?.getValues()?.attribute1?.toString();
    // let url = `/api/v1/TblDebtGroup/get-list?Skip=0&Take=1000&KeySearch=${
    //   search ?? "KL"
    // }`;
    let url = `/api/v1/TblDebtGroup/get-list?Skip=0&Take=1000`;

    try {
      const response = await repositoryPos.get<MessageResponse<any[]>>(url);
      if (response?.success && response?.data) {
        const data = response.data;
        const mappedData = Array.from(
          new Map(
            data.map((value) => [
              value?.groupCode,
              {
                value: value?.groupCode?.toString(),
                label: `${value?.groupCode?.toString()}`,
              },
            ]),
          ).values(),
        );
        setDataTblDebtGroup(mappedData);
      } else {
        setDataTblDebtGroup([]);
      }
    } catch (error) {
      setDataTblDebtGroup([]);
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    async function callApi() {
      await Promise.all([fetchDataDebt(), callApiGetData()]);
    }
    if (id) callApi();
  }, [id]);

  useEffect(() => {
    const lisInfoAddress = form.getValues().listInfoAddress;
    const currentProvince =
      String(form.getValues()?.type) === "1" ||
      String(form.getValues()?.type) === "4"
        ? form.getValues()?.attribute13
        : lisInfoAddress?.[currentIndexKHDC]?.province;

    if (currentProvince) {
      dataCommuneSelect(currentProvince);
    }
    if (!currentProvince) {
      setDataTblCommune([]);
    }
  }, [
    currentIndexKHDC,
    form.getValues().attribute13,
    form.getValues().listInfoAddress?.[currentIndexKHDC]?.province,
  ]);

  // useEffect(() => {
  //   const lisInfoAddress = form.getValues().listInfoAddress;
  //   const currentProvince =
  //     String(form.getValues()?.type) === "1"
  //       ? form.getValues()?.district
  //       : lisInfoAddress?.[currentIndexKHDC]?.district;
  //   if (currentProvince) {
  //     dataCommuneSelect(currentProvince);
  //   }
  //   if (!currentProvince) {
  //     setDataTblCommune([]);
  //   }
  // }, [
  //   currentIndexKHDC,
  //   form.getValues().district,
  //   form.getValues().listInfoAddress?.[currentIndexKHDC]?.district,
  // ]);

  useEffect(() => {
    if (
      form.getValues()?.listInfoAddress &&
      Array.isArray(form.getValues()?.listInfoAddress) &&
      String(form.getValues()?.type) !== "1" &&
      String(form.getValues()?.type) !== "4"
    ) {
      const listInfoAddress = form.getValues()?.listInfoAddress;

      setListInfoAddressText({
        provinceName:
          listInfoAddress[currentIndexKHDC]?.province &&
          listInfoAddress[currentIndexKHDC]?.province?.length > 0
            ? getValueById(
                listInfoAddress[currentIndexKHDC]?.province,
                dataTblProvince,
                "label",
              )
            : "",
        communeName:
          listInfoAddress[currentIndexKHDC]?.commune &&
          listInfoAddress[currentIndexKHDC]?.commune?.length > 0
            ? getValueById(
                listInfoAddress[currentIndexKHDC]?.commune,
                dataTblCommune,
                "label",
              )
            : "",
      });
    } else if (
      String(form.getValues()?.type) === "1" ||
      String(form.getValues()?.type) === "4"
    ) {
      const infoAddress = form.getValues();

      setListInfoAddressText({
        provinceName:
          infoAddress?.attribute13 && infoAddress?.attribute13?.length > 0
            ? getValueById(infoAddress?.attribute13, dataTblProvince, "label")
            : "",
        communeName:
          infoAddress?.attribute14 && infoAddress?.attribute14?.length > 0
            ? getValueById(infoAddress?.attribute14, dataTblCommune, "label")
            : "",
      });
    }
  }, [
    form.getValues()?.listInfoAddress,
    form.getValues()?.attribute13,
    form.getValues()?.attribute14,
    dataTblCommune,
    currentIndexKHDC,
  ]);

  return (
    <Box
      component="form"
      mx="auto"
      w={{
        base: "400px",
        xs: "500px",
        sm: "700px",
        md: "850px",
        lg: "900px",
      }}
      style={{ position: "relative" }}
    >
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />

      <Grid mt={10}>
        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <Grid>
            <Grid.Col span={6}>
              <Select
                rightSection={<></>}
                label={"Loại KH"}
                data={[
                  {
                    value: "1",
                    label: "Cá nhân",
                  },
                  {
                    value: "2",
                    label: "Doanh nghiệp",
                  },
                  {
                    value: "3",
                    label: "Doanh nghiệp được cấp hạn mức",
                  },
                  {
                    value: "4",
                    label: "Nhân viên HACOM",
                  },
                ]}
                readOnly
                variant="filled"
                allowDeselect={false}
                value={form.getValues()?.type?.toString() ?? null}
                {...form.getInputProps("type")}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              {form.getValues().type?.toString() === "3" ||
              form.getValues().type?.toString() === "4" ? (
                <TextInput
                  label="Đối tượng công nợ"
                  value={form.getValues()?.code}
                  variant="filled"
                  readOnly
                />
              ) : (
                <Tooltip
                  label={
                    getItemFromData(
                      dataTblDebtGroup,
                      form.getValues().attribute1,
                    )?.label
                  }
                >
                  <Select
                    rightSection={<></>}
                    label={"Đối tượng công nợ"}
                    readOnly
                    variant="filled"
                    value={form.getValues().attribute1?.toString() ?? null}
                    data={dataTblDebtGroup}
                    key={form.key("attribute1")}
                    {...form.getInputProps("attribute1")}
                  />
                </Tooltip>
              )}
            </Grid.Col>
          </Grid>
        </Grid.Col>

        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <Grid>
            <Grid.Col span={6}>
              <TextInput
                label={"MSKH"}
                type="text"
                readOnly
                variant="filled"
                key={form.key("code")}
                {...form.getInputProps("code")}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <Select
                rightSection={<></>}
                label={"Nhóm khách hàng"}
                searchable
                readOnly
                variant="filled"
                value={form.getValues().groupId?.toString() ?? null}
                data={
                  String(form.getValues()?.type) === "4"
                    ? dataTblCustomerGroup.filter(
                        (value: any) => value?.att1 === "3",
                      )
                    : dataTblCustomerGroup.filter(
                        (value: any) =>
                          value?.att1 === form?.getValues().type?.toString(),
                      )
                }
                {...form.getInputProps("groupId")}
              />
            </Grid.Col>
          </Grid>
        </Grid.Col>

        <Grid.Col span={12} py={0}>
          <Grid>
            <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
              <Grid>
                <Grid.Col span={12}>
                  <TextInput
                    label={"Tên doanh nghiệp"}
                    type="text"
                    readOnly
                    variant="filled"
                    {...form.getInputProps("companyName")}
                  />
                </Grid.Col>
                {String(form.getValues().type) !== "1" &&
                  String(form.getValues().type) !== "4" && (
                    <>
                      <Grid.Col span={6}>
                        <TextInput
                          label={"Email nhận giá trị gia tăng"}
                          placeholder={"Nhập email nhận giá trị gia tăng"}
                          type="email"
                          // withAsterisk={form.getValues().type?.toString() !== "1"}
                          readOnly
                          variant="filled"
                          {...form.getInputProps("email")}
                        />
                      </Grid.Col>
                      <Grid.Col span={6}>
                        <TextInput
                          label={"Số điện thoại công ty"}
                          placeholder={"Số điện thoại công ty"}
                          type="number"
                          // withAsterisk={form.getValues().type?.toString() !== "1"}
                          readOnly
                          variant="filled"
                          {...form.getInputProps("telephoneNumber")}
                        />
                      </Grid.Col>
                    </>
                  )}
                <Grid.Col span={6}>
                  <TextInput
                    label={"Mã số thuế"}
                    type="text"
                    readOnly
                    variant="filled"
                    {...form.getInputProps("taxCode")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <Select
                    label={"Nhóm khách hàng giảm giá"}
                    placeholder={"Chọn nhóm khách hàng giảm giá"}
                    data={[
                      { label: "Nhóm 1", value: "N1" },
                      { label: "Nhóm 2", value: "N2" },
                      { label: "Nhóm 3", value: "N3" },
                    ]}
                    value={form.getValues()?.attribute10?.toString()}
                    readOnly
                    variant="filled"
                  />
                </Grid.Col>
              </Grid>
              {String(form.getValues().type) !== "1" &&
              String(form.getValues().type) !== "4" ? (
                <>
                  <Fieldset legend={`Người mua hàng`}>
                    <Flex
                      direction={"row"}
                      align={"center"}
                      justify={"space-between"}
                      gap={"md"}
                    >
                      <Box></Box>
                      <Flex
                        direction={"row"}
                        align={"center"}
                        gap={"md"}
                        pl={10}
                      >
                        <Tooltip label={"Sau"}>
                          <ActionIcon
                            variant="light"
                            onClick={() => prevCustomer(1)}
                            disabled={currentIndexKH === 0}
                            size={"sm"}
                          >
                            <IconCaretLeft stroke={2} />
                          </ActionIcon>
                        </Tooltip>
                        <Box>
                          <Text
                            size="md"
                            style={{
                              fontWeight: "bold",
                            }}
                          >
                            Người mua hàng {currentIndexKH + 1}
                          </Text>
                        </Box>
                        <Tooltip label={"Trước"}>
                          <ActionIcon
                            variant="light"
                            onClick={() => nextCustomer(1)}
                            disabled={
                              currentIndexKH ===
                              form.getValues().listInfoCustomers.length - 1
                            }
                            size={"sm"}
                          >
                            <IconCaretRight stroke={2} />
                          </ActionIcon>
                        </Tooltip>
                      </Flex>
                      <Box>
                        <Tooltip label={"Thêm người"}>
                          <ActionIcon
                            variant="light"
                            // onClick={() => {
                            //   handleAddCustomer();
                            // }}
                            size={"sm"}
                            disabled
                          >
                            <IconCirclePlus stroke={2} />
                          </ActionIcon>
                        </Tooltip>
                      </Box>
                    </Flex>

                    {/* <ScrollArea h={310} scrollbars="y"> */}
                    <Stack>
                      {form.getValues().listInfoCustomers.length > 0 && (
                        <Box>
                          <Grid key={currentIndexKH}>
                            <Grid.Col span={12}>
                              <TextInput
                                label={"Họ và tên"}
                                placeholder={"Nhập họ và tên"}
                                variant="filled"
                                type="text"
                                withAsterisk
                                {...form.getInputProps(
                                  `listInfoCustomers.${currentIndexKH}.name`,
                                )}
                                readOnly
                              />
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <Select
                                label={"Giới tính"}
                                placeholder={"Chọn giới tính"}
                                type="text"
                                clearable
                                variant="filled"
                                readOnly
                                data={[
                                  {
                                    value: "1",
                                    label: "Nam",
                                  },
                                  {
                                    value: "2",
                                    label: "Nữ",
                                  },
                                  {
                                    value: "3",
                                    label: "Khác",
                                  },
                                ]}
                                value={
                                  form.getValues()?.listInfoCustomers?.[
                                    currentIndexKH
                                  ]?.sex ?? null
                                }
                                {...form.getInputProps(
                                  `listInfoCustomers.${currentIndexKH}.sex`,
                                )}
                              />
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <DateInput
                                label="Ngày sinh nhật"
                                placeholder="Chọn ngày sinh nhật"
                                locale="vi"
                                clearable
                                variant="filled"
                                readOnly
                                maxDate={new Date()}
                                valueFormat="DD-MM-YYYY"
                                dateParser={(input) => {
                                  const [day, month, year] = input
                                    .split("-")
                                    .map(Number);
                                  return new Date(
                                    Date.UTC(year, month - 1, day),
                                  ); // Tạo Date ở UTC
                                }}
                                value={
                                  form.getValues()?.listInfoCustomers[
                                    currentIndexKH
                                  ]?.birthOfDate
                                    ? new Date(
                                        form.getValues()?.listInfoCustomers[
                                          currentIndexKH
                                        ]?.birthOfDate,
                                      )
                                    : undefined
                                }
                                {...form.getInputProps(
                                  `listInfoCustomers.${currentIndexKH}.birthOfDate`,
                                )}
                                onChange={(value) => {
                                  if (value) {
                                    // Lưu giá trị ISO với thời gian ở UTC
                                    const utcDate = new Date(
                                      Date.UTC(
                                        value.getFullYear(),
                                        value.getMonth(),
                                        value.getDate(),
                                      ),
                                    );
                                    form.setFieldValue(
                                      `listInfoCustomers.${currentIndexKH}.birthOfDate`,
                                      utcDate.toISOString(),
                                    );
                                  } else {
                                    form.setFieldValue(
                                      `listInfoCustomers.${currentIndexKH}.birthOfDate`,
                                      undefined,
                                    );
                                  }
                                }}
                              />
                            </Grid.Col>

                            <Grid.Col span={12}>
                              <TextInput
                                label={"Số điện thoại"}
                                readOnly
                                variant="filled"
                                placeholder={"Nhập số điện thoại"}
                                type="number"
                                withAsterisk
                                {...form.getInputProps(
                                  `listInfoCustomers.${currentIndexKH}.telephoneNumber`,
                                )}
                              />
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <TextInput
                                label={"Email"}
                                type="text"
                                readOnly
                                variant="filled"
                                {...form.getInputProps(
                                  `listInfoCustomers.${currentIndexKH}.attribute1`,
                                )}
                              />
                            </Grid.Col>
                          </Grid>
                        </Box>
                      )}
                    </Stack>
                    {/* </ScrollArea> */}
                  </Fieldset>
                </>
              ) : (
                <>
                  <Fieldset legend="Người mua hàng">
                    <Grid>
                      <Grid.Col span={12}>
                        <TextInput
                          label={"Họ và tên"}
                          type="text"
                          readOnly
                          variant="filled"
                          key={"name"}
                          {...form.getInputProps("name")}
                        />
                      </Grid.Col>

                      <Grid.Col span={12}>
                        <Select
                          rightSection={<></>}
                          readOnly
                          variant="filled"
                          label={"Giới tính"}
                          type="text"
                          data={[
                            {
                              value: "1",
                              label: "Nam",
                            },
                            {
                              value: "2",
                              label: "Nữ",
                            },
                            {
                              value: "3",
                              label: "Khác",
                            },
                          ]}
                          value={form.getValues().sex?.toString() ?? null}
                          key={"sex"}
                          {...form.getInputProps("sex")}
                        />
                      </Grid.Col>
                      <Grid.Col span={12}>
                        <DateInput
                          label={"Ngày sinh nhật"}
                          locale="vi"
                          maxDate={new Date()}
                          valueFormat="DD-MM-YYYY"
                          readOnly
                          variant="filled"
                          value={
                            form.getValues().birthOfDate
                              ? new Date(
                                  form.getValues().birthOfDate?.toString(),
                                )
                              : undefined
                          }
                          key={"birthOfDate"}
                          {...form.getInputProps("birthOfDate")}
                        />
                      </Grid.Col>

                      <Grid.Col span={12}>
                        <TextInput
                          label={"Số điện thoại"}
                          type="number"
                          readOnly
                          variant="filled"
                          key={"telephoneNumber"}
                          {...form.getInputProps("telephoneNumber")}
                        />
                      </Grid.Col>
                    </Grid>
                  </Fieldset>
                </>
              )}

              <Grid>
                {form.getValues().type?.toString() === "1" ||
                form.getValues().type?.toString() === "4" ? (
                  <Grid.Col span={12}>
                    <TextInput
                      label={"Email"}
                      type="text"
                      readOnly
                      variant="filled"
                      {...form.getInputProps("email")}
                    />
                  </Grid.Col>
                ) : null}
              </Grid>
            </Grid.Col>

            <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
              <Fieldset legend="Công nợ" mt={"md"}>
                <Grid>
                  <Grid.Col span={{ base: 12, md: 6 }}>
                    <NumberInput
                      readOnly
                      variant="filled"
                      label={"Thời hạn công nợ (ngày)"}
                      hideControls
                      value={Number(form.getValues()?.attribute2)}
                      key={"attribute2"}
                      {...form.getInputProps("attribute2")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 6 }}>
                    <NumberInput
                      readOnly
                      variant="filled"
                      label={"Hạn mức công nợ"}
                      thousandSeparator=","
                      hideControls
                      value={Number(form.getValues()?.debtLimit)}
                      key={"debtLimit"}
                      {...form.getInputProps("debtLimit")}
                    />
                  </Grid.Col>
                </Grid>
              </Fieldset>

              {String(form.getValues().type) !== "1" &&
              String(form.getValues().type) !== "4" ? (
                <>
                  <Fieldset mt="7px" legend="Địa chỉ">
                    <Flex
                      direction={"row"}
                      align={"center"}
                      justify={"space-between"}
                      gap={"md"}
                    >
                      <Box></Box>
                      <Flex
                        direction={"row"}
                        align={"center"}
                        gap={"md"}
                        pl={10}
                      >
                        <Tooltip label={"Sau"}>
                          <ActionIcon
                            variant="light"
                            onClick={() => prevCustomer(2)}
                            disabled={currentIndexKHDC === 0}
                            size={"sm"}
                          >
                            <IconCaretLeft stroke={2} />
                          </ActionIcon>
                        </Tooltip>
                        <Box>
                          <Text
                            size="md"
                            style={{
                              fontWeight: "bold",
                            }}
                          >
                            {`Địa chỉ giao hàng ${currentIndexKHDC + 1}`}
                          </Text>
                        </Box>
                        <Tooltip label={"Trước"}>
                          <ActionIcon
                            variant="light"
                            onClick={() => nextCustomer(2)}
                            disabled={
                              currentIndexKHDC ===
                              form.getValues().listInfoAddress.length - 1
                            }
                            size={"sm"}
                          >
                            <IconCaretRight stroke={2} />
                          </ActionIcon>
                        </Tooltip>
                      </Flex>
                      <Box>
                        <Tooltip label={"Thêm người"}>
                          <ActionIcon
                            variant="light"
                            // onClick={() => {
                            //   handleAddCustomer();
                            // }}
                            disabled
                            size={"sm"}
                          >
                            <IconCirclePlus stroke={2} />
                          </ActionIcon>
                        </Tooltip>
                      </Box>
                    </Flex>
                    <Stack>
                      {form.getValues().listInfoAddress.length > 0 && (
                        <Box>
                          <Grid key={currentIndexKHDC}>
                            <Grid.Col span={{ base: 12 }}>
                              <Select
                                label={"Tỉnh/Thành phố"}
                                placeholder={"Chọn Tỉnh/Thành phố"}
                                searchable
                                clearable
                                readOnly
                                variant="filled"
                                value={
                                  form.getValues()?.listInfoAddress?.[
                                    currentIndexKHDC
                                  ]?.province ?? null
                                }
                                data={dataTblProvince}
                                onClick={async () => {
                                  if (dataTblProvince.length === 0) {
                                    await dataProvinceSelect();
                                  }
                                }}
                                {...form.getInputProps(
                                  `listInfoAddress.${currentIndexKHDC}.province`,
                                )}
                                onChange={(value) => {
                                  form.setFieldValue(
                                    `listInfoAddress.${currentIndexKHDC}.province`,
                                    value?.toString(),
                                  );
                                  form.setFieldValue(
                                    `listInfoAddress.${currentIndexKHDC}.district`,
                                    null,
                                  );
                                  form.setFieldValue(
                                    `listInfoAddress.${currentIndexKHDC}.commune`,
                                    null,
                                  );
                                }}
                              />
                            </Grid.Col>
                          </Grid>
                          {/*<Grid.Col span={{ base: 12 }}>
                               <Select
                                label={"Quận/Huyện"}
                                placeholder={"Chọn Quận/Huyện"}
                                searchable
                                clearable
                                readOnly
                                variant="filled"
                                withAsterisk={
                                  form.getValues().type?.toString() !== "1"
                                }
                                disabled={dataTblDistrict?.length === 0}
                                data={dataTblDistrict}
                                value={
                                  form.getValues()?.listInfoAddress?.[
                                    currentIndexKHDC
                                  ]?.district ?? null
                                }
                                {...form.getInputProps(
                                  `listInfoAddress.${currentIndexKHDC}.district`
                                )}
                                onChange={(value) => {
                                  form.setFieldValue(
                                    `listInfoAddress.${currentIndexKHDC}.district`,
                                    value?.toString()
                                  );
                                  form.setFieldValue(
                                    `listInfoAddress.${currentIndexKHDC}.commune`,
                                    null
                                  );
                                }}
                              />
                            </Grid.Col> */}
                          <Grid>
                            <Grid.Col span={{ base: 12 }}>
                              <Select
                                label={"Phường/Xã"}
                                placeholder={"Nhập Phường/Xã"}
                                searchable
                                clearable
                                readOnly
                                variant="filled"
                                disabled={dataTblCommune?.length === 0}
                                data={dataTblCommune}
                                value={
                                  form.getValues()?.listInfoAddress?.[
                                    currentIndexKHDC
                                  ]?.commune ?? null
                                }
                                {...form.getInputProps(
                                  `listInfoAddress.${currentIndexKHDC}.commune`,
                                )}
                                onChange={(value) => {
                                  form.setFieldValue(
                                    `listInfoAddress.${currentIndexKHDC}.commune`,
                                    value?.toString(),
                                  );
                                }}
                              />
                            </Grid.Col>
                          </Grid>
                          <Grid>
                            <Grid.Col span={{ base: 12 }}>
                              <TextInput
                                label={
                                  "Địa chỉ cụ thể (Không bao gồm tên tỉnh/TP, phường/xã)"
                                }
                                h={"100%"}
                                readOnly
                                variant="filled"
                                placeholder={"Nhập địa chỉ cụ thể"}
                                {...form.getInputProps(
                                  `listInfoAddress.${currentIndexKHDC}.address`,
                                )}
                              />
                            </Grid.Col>
                          </Grid>
                          {listInfoAddressText.provinceName.length > 0 ||
                          form.getValues()?.listInfoAddress[currentIndexKHDC]
                            ?.address?.length > 0 ? (
                            <Grid ml={10}>
                              <Grid.Col span={12}>
                                <Text fw={500} size="11.5px">
                                  Địa chỉ:{" "}
                                  {`${
                                    form.getValues()?.listInfoAddress[
                                      currentIndexKHDC
                                    ]?.address
                                      ? form.getValues()?.listInfoAddress[
                                          currentIndexKHDC
                                        ]?.address
                                      : ""
                                  } ${
                                    listInfoAddressText.communeName.length > 0
                                      ? ", " + listInfoAddressText.communeName
                                      : ""
                                  } ${
                                    listInfoAddressText.provinceName.length > 0
                                      ? ", " + listInfoAddressText.provinceName
                                      : ""
                                  }`}
                                </Text>
                              </Grid.Col>
                            </Grid>
                          ) : (
                            <></>
                          )}
                        </Box>
                      )}{" "}
                    </Stack>
                    <Divider />
                    <Grid mt={10}>
                      <Grid.Col span={12}>
                        <TextInput
                          label="Địa chỉ VAT"
                          placeholder="Địa chỉ VAT"
                          value={addressCurrentVAT}
                          onChange={(e) =>
                            setAddressCurrentVAT(e.currentTarget.value)
                          }
                          variant="filled"
                          readOnly
                        />
                      </Grid.Col>
                    </Grid>
                    {/* <Grid>
                      <Grid.Col span={{ base: 12 }}>
                        <Checkbox
                          label="Khách hàng không cung cấp địa chỉ"
                          checked={
                            form.getValues()?.attribute12
                              ? form.getValues()?.attribute12
                              : false
                          }
                          readOnly
                        />
                      </Grid.Col>
                    </Grid> */}
                  </Fieldset>
                </>
              ) : (
                <>
                  <Fieldset mt="7px" legend="Địa chỉ">
                    <Grid>
                      <Grid.Col span={{ base: 12 }}>
                        <Select
                          rightSection={<></>}
                          readOnly
                          variant="filled"
                          label={"Tỉnh/Thành phố"}
                          searchable
                          data={dataTblProvince}
                          onClick={async () => {
                            if (dataTblProvince.length === 0) {
                              await dataProvinceSelect();
                            }
                          }}
                          value={
                            form.getValues().attribute13?.toString() ?? null
                          }
                          {...form.getInputProps("attribute13")}
                        />
                      </Grid.Col>
                      {/* <Grid.Col span={{ base: 12 }}>
                        <Select
                          rightSection={<></>}
                          label={"Quận/Huyện"}
                          searchable
                          readOnly
                          variant="filled"
                          data={dataTblDistrict}
                          value={form.getValues().district?.toString() ?? null}
                          {...form.getInputProps("district")}
                        />
                      </Grid.Col> */}
                      <Grid.Col span={{ base: 12 }}>
                        <Select
                          rightSection={<></>}
                          label={"Phường/Xã"}
                          searchable
                          readOnly
                          variant="filled"
                          data={dataTblCommune}
                          value={
                            form.getValues().attribute14?.toString() ?? null
                          }
                          {...form.getInputProps("attribute14")}
                        />
                      </Grid.Col>
                      <Grid.Col span={{ base: 12 }}>
                        <TextInput
                          label={
                            "Địa chỉ cụ thể (Không bao gồm tên tỉnh/TP, phường/xã)"
                          }
                          h={"100%"}
                          readOnly
                          variant="filled"
                          {...form.getInputProps("address")}
                        />
                      </Grid.Col>
                      {listInfoAddressText.provinceName.length > 0 ||
                      (form.getValues()?.address &&
                        form.getValues()?.address?.length > 0) ? (
                        <Grid ml={10}>
                          <Grid.Col span={12}>
                            <Text fw={500} size="11.5px">
                              Địa chỉ:{" "}
                              {`${
                                form.getValues()?.address
                                  ? form.getValues()?.address
                                  : ""
                              } ${
                                listInfoAddressText.communeName.length > 0
                                  ? ", " + listInfoAddressText.communeName
                                  : ""
                              } ${
                                listInfoAddressText.provinceName.length > 0
                                  ? ", " + listInfoAddressText.provinceName
                                  : ""
                              }`}
                            </Text>
                          </Grid.Col>
                        </Grid>
                      ) : (
                        <></>
                      )}
                      {/* <Grid.Col span={{ base: 12 }}>
                        <Checkbox
                          label="Khách hàng không cung cấp địa chỉ"
                          checked={
                            form.getValues()?.attribute12
                              ? form.getValues()?.attribute12
                              : false
                          }
                          readOnly
                        />
                      </Grid.Col> */}
                    </Grid>
                  </Fieldset>
                </>
              )}
            </Grid.Col>
          </Grid>
        </Grid.Col>
      </Grid>

      <Group
        justify="end"
        mt="xs"
        style={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <Button
          type="button"
          color="gray"
          loading={visible}
          onClick={() => {
            modals.closeAll();
          }}
          leftSection={!visible ? <IconWindow size={18} /> : undefined}
        >
          Đóng
        </Button>

        <></>
      </Group>
    </Box>
  );
};

export default DetailDataView;

type DetailDataViewProps = {
  id: string | number;
};
